import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
	IAuthenticationMeetingsChangePassword,
	IAuthenticationMeetingsConfirmUser,
	IAuthenticationMeetingsLoginUser,
	IAuthenticationMeetingsRegistration,
	IAuthenticationMeetingsRemindUser,
} from '../authentication.interfaces';

import { ICommonResponseError } from '../../../../Common/@types/core';

const urls = {
	login: 'account/login',
	confirm: 'account/verifyCode',
	registration: 'account/register',
	resetPassword: 'account/resetPassword',
	code: 'account/sendCode',
	changePassword: 'account/applyPassword',
};

export interface IAuthenticationMeetingsUserActionsResponse extends ICommonResponseError {
	IsSuccess: boolean;
	ErrorMessages?: string[];
	Result: {
		ExpiresAt: string;
	};
}

@Injectable()
export class AuthenticationMeetingsUserService {
	constructor (
		private http: HttpClient,
	) {}

	login (data: IAuthenticationMeetingsLoginUser): Observable<IAuthenticationMeetingsUserActionsResponse> {
		return this.http.post<IAuthenticationMeetingsUserActionsResponse>(urls.login, data);
	}

	confirm (data: IAuthenticationMeetingsConfirmUser): Observable<IAuthenticationMeetingsUserActionsResponse> {
		return this.http.post<IAuthenticationMeetingsUserActionsResponse>(urls.confirm, { ...data, Purpose: 'TwoFactor' });
	}

	resetPassword (data: IAuthenticationMeetingsRemindUser): Observable<IAuthenticationMeetingsUserActionsResponse> {
		return this.http.post<IAuthenticationMeetingsUserActionsResponse>(urls.resetPassword, data);
	}

	changePassword (data: IAuthenticationMeetingsChangePassword): Observable<IAuthenticationMeetingsUserActionsResponse> {
		return this.http.post<IAuthenticationMeetingsUserActionsResponse>(urls.changePassword, data);
	}

	register (data: IAuthenticationMeetingsRegistration): Observable<IAuthenticationMeetingsUserActionsResponse> {
		return this.http.post<IAuthenticationMeetingsUserActionsResponse>(urls.registration, data);
	}

	sendCode (): Observable<IAuthenticationMeetingsUserActionsResponse> {
		return this.http.post<IAuthenticationMeetingsUserActionsResponse>(urls.code, { Purpose: 'TwoFactor' });
	}
}
